import translations from "@neoBabel/de.json"
import I18n from "../src/helper/i18nInstance"
import tmpTranslations from "../src/tmpBabel.json"
import _ from "lodash"
import BABEL_VERSION from "../src/forceBabelRebuild"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const babel_version = BABEL_VERSION

I18n.defaultLocale = "de"
I18n.locale = "de"
// Deep-merge tmpTranslations onto translations, so tmpBabel.json can add individual
// sub-keys to a translation area without wiping out sibling keys already there.
I18n.store(_.merge({}, translations, tmpTranslations))

import "../src/index"
